import BillingCategoryBaseController from "../common/billing_category.base.controller";

class BillingCategoryCreateController extends BillingCategoryBaseController {
    /*@ngInject*/
    constructor(Auth, User, $state, $translate, $stateParams, $location, Modal, BillingCategoryService) {

        super(Auth, $state, User, BillingCategoryService, Modal, $translate, $stateParams)

        this.Auth = Auth;
        this.User = User;
        this.$state = $state;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$location = $location;
        this.Modal = Modal;
        this.BillingCategoryService = BillingCategoryService;

        this.defaultModel = {
            isCreate: false,
            branchId: User.getUser().branchId,
            name: null,
            description: null,
            status: true,
            errorMessage: '',
            generalLedgerCode: null,
        }
        
        this.model = angular.copy(this.defaultModel)
    }

    $onInit() {}

    submit() {
        this.model.isCreate = true;
        delete this.model.errorMessage;

        this.Service.create({
            name: this.model.name,
            description: this.model.description,
            status: this.model.status,
            branchId: this.model.branchId,
            generalLedgerCode: this.model.generalLedgerCode
        })
            .then(() => {
                this.askCreate();
            })
            .catch((err) => {
                err.data.errors.map((e) => {
                    this.model.errorMessage = e.message;
                })
            })
            .finally(() => {
                this.model.isCreate = false;
            })
    }

    reset() {
        this.model = angular.copy(this.defaultModel);
        this.clearErrors();
    }
}

export default BillingCategoryCreateController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/billing_category/create/billing_category.create.controller.js